<div *ngIf="seenBy?.length > 0" [@.disabled]="false && !runAnimation" [@growAnimation]>
  <div class="avatar-list-box" (click)="openSeenDialog()">
    <app-avatar *ngFor="let avatar of accountAvatarList" [accountAvatarRecord]="avatar"></app-avatar>
    <span class="plus-seen" *ngIf="seenBy.length > AVATAR_COUNT">+{{ this.seenBy.length - AVATAR_COUNT }}</span>
  </div>
</div>
